module.exports = __webpack_public_path__ + "statics/img/shengcheng.6ec8cb8e.png";